namespace GeniuzPOS.ReportMasterData {
    export interface Report_1311Form {
        ShopId: Serenity.LookupEditor;
        ShopName: Serenity.StringEditor;
        CatCode: Serenity.LookupEditor;
        CatName: Serenity.StringEditor;
        Qty: Serenity.DecimalEditor;
        GrossSales: Serenity.DecimalEditor;
        AllItemDiscount: Serenity.DecimalEditor;
        NetSalesExVat: Serenity.DecimalEditor;
        VatOfNetSales: Serenity.DecimalEditor;
    }

    export class Report_1311Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1311';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1311Form.init)  {
                Report_1311Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(Report_1311Form, [
                    'ShopId', w0,
                    'ShopName', w1,
                    'CatCode', w0,
                    'CatName', w1,
                    'Qty', w2,
                    'GrossSales', w2,
                    'AllItemDiscount', w2,
                    'NetSalesExVat', w2,
                    'VatOfNetSales', w2
                ]);
            }
        }
    }
}
